import React from "react";
import { Link } from "react-router-dom";
import "../cover/cover.css";

const Cover = ({ breadcrumb }) => {
  return (
    <div className="breadcrumb-container">
      <nav className="breadcrumb-nav">
        {breadcrumb.map((crumb, index) => (
          <React.Fragment key={index}>
            {index < breadcrumb.length - 1 ? (
              <>
                <Link 
                  to={`/${breadcrumb.slice(0, index + 1).join("/").toLowerCase()}`} 
                  className="breadcrumb-link"
                >
                  {crumb}
                </Link>
                <span className="breadcrumb-separator"> / </span>
              </>
            ) : (
              <span className="breadcrumb-current">{crumb}</span>
            )}
          </React.Fragment>
        ))}
      </nav>
    </div>
  );
};

export default Cover;
